import React from 'react';
import { motion } from 'framer-motion';
import { Star } from 'lucide-react';
export function TrustBar() {
  const items = ['AOG Support', 'MRO & Airline Partners', 'Scheduled & Expedited', 'Professional Crew', 'Nationwide Coverage', '24/7 Dispatch'];
  // Duplicate items to create seamless loop
  const duplicatedItems = [...items, ...items, ...items];
  return <div className="w-full bg-navy border-y border-white/5 py-4 overflow-hidden flex items-center relative z-20" data-id="element-379">
      <div className="absolute left-0 top-0 bottom-0 w-16 bg-gradient-to-r from-navy to-transparent z-10" data-id="element-380"></div>
      <div className="absolute right-0 top-0 bottom-0 w-16 bg-gradient-to-l from-navy to-transparent z-10" data-id="element-381"></div>

      <motion.div className="flex whitespace-nowrap items-center" animate={{
      x: ['0%', '-50%']
    }} transition={{
      repeat: Infinity,
      ease: 'linear',
      duration: 30
    }} data-id="element-382">
        {duplicatedItems.map((item, index) => <div key={index} className="flex items-center mx-8" data-id="element-383">
            <span className="text-slate-400 font-heading tracking-widest uppercase text-sm md:text-base" data-id="element-384">
              {item}
            </span>
            <Star className="w-3 h-3 text-gold mx-8 fill-gold opacity-50" data-id="element-385" />
          </div>)}
      </motion.div>
    </div>;
}